<template>
  <div style="margin: 5px 0">
    <div>
      <el-select v-if="items.includes('type_id')" v-model="reginWhere.type_id" @change="selectTypeList()" filterable class="m-2" placeholder="选择分类" clearable size="mini">
        <el-option
          v-for="(item,index) in reginWhere.type_list"
          :key="index"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select v-if="items.includes('place_id')" v-model="reginWhere.place_id" @change="selectPlaceList()" filterable style="width: 150px;" placeholder="华南/华东" clearable size="mini">
        <el-option
          v-for="(item,index) in reginWhere.place_list"
          :key="index"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select v-if="items.includes('region_id')" v-model="reginWhere.project_region" @change="selectProjectRegin()" filterable class="m-2" placeholder="选择战区" clearable size="mini">
        <template v-for="(item,index) in reginWhere.project_region_list">
          <el-option :label="item.name" :value="item.id" :key="index"/>
          <template v-for="(sub,sub_index) in item.children" >
            <el-option :label="'    --  ' + sub.name" :value="sub.id" :key="index+'-'+sub_index" />
          </template>
        </template>
      </el-select>
      <el-select v-if="items.includes('project_id')" v-model="reginWhere.project_name" class="m-2" filterable placeholder="选择项目" clearable size="mini">
        <el-option
          v-for="item in reginWhere.project_list"
          :key="item.erp_pindex_id"
          :label="item.house_name"
          :value="item.erp_pindex_id"
        />
      </el-select>
      <!-- <el-select v-if="items.includes('area_id')" v-model="reginWhere.area_id" @change="selectArea()" class="m-2" filterable placeholder="选择区域" clearable size="mini">
        <el-option
          v-for="item in reginWhere.area_list"
          :key="item.house_id"
          :label="item.house_name"
          :value="item.house_id"
        />
      </el-select> -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
import UserProjectInfo from "../../common/UserProjectInfo";
import search_condition from "../../../../../assets/js/search_condition";

export default {
  name: "SelectCdjProjectHeaderNotArea",
  props:{
    items:{
      type:Array,
      default:()=>['type_id','place_id','region_id','project_id','area_id']
    }
  },
  data(){
    return{
      reginWhere:{
        type_id:1,
        type_list:[],
        place_id:'',
        place_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[],
        level:0,
        age:1
      },
    }
  },
  activated() {
    const that=this;
    that.getAllTree(()=>{
      that.initLegalSearchObj()
    })
  },
  methods:{
    getAllTree(callback){
      const that=this;
      UserProjectInfo.ready(callback,1)

    },
    selectTypeList(){
      const that=this;
      // 物业端完成率
      that.reginWhere.place_list = [];
      that.reginWhere.place_id='';
      that.reginWhere.project_region_list = [];
      that.reginWhere.project_region='';
      that.reginWhere.project_list = [];
      that.reginWhere.area_list = [];
      that.reginWhere.project_name = '';
      that.reginWhere.area_id = '';
      that.reginWhere.group_by = 'project';

      //插入下拉框
      that.reginWhere.place_list = UserProjectInfo.getPlaceList(that.reginWhere.type_id);
      that.reginWhere.type_list = UserProjectInfo.getTypeList();
      that.reginWhere.project_region_list = UserProjectInfo.getRegionList({
        type_id: that.reginWhere.type_id,
        place_id: that.reginWhere.place_id,
      });
      that.reginWhere.project_list = UserProjectInfo.getProjectList({
        type_id: that.reginWhere.type_id,
        place_id: that.reginWhere.place_id,
        region_id: that.reginWhere.project_region,
      });
      that.reginWhere.project_ids = UserProjectInfo.getProjectIds({
        type_id: that.reginWhere.type_id,
        place_id: that.reginWhere.place_id,
        region_id: that.reginWhere.project_region,
      });
      that.setLegalSearchObj();
      that.$emit("onHeader",that.reginWhere);
    },
    selectPlaceList(){
      const that=this;

      that.reginWhere.project_region_list = [];
      that.reginWhere.project_region='';
      that.reginWhere.project_list = [];
      that.reginWhere.area_list = [];
      that.reginWhere.project_name = '';
      that.reginWhere.area_id = '';
      that.reginWhere.group_by = 'project';

      //插入下拉框
      that.reginWhere.type_list = UserProjectInfo.getTypeList();
      that.reginWhere.project_region_list = UserProjectInfo.getRegionList({
        type_id: that.reginWhere.type_id,
        place_id: that.reginWhere.place_id,
      });
      that.reginWhere.project_list = UserProjectInfo.getProjectList({
        type_id: that.reginWhere.type_id,
        region_id: that.reginWhere.project_region,
        place_id: that.reginWhere.place_id,
      });
      that.reginWhere.project_ids = UserProjectInfo.getProjectIds({
        type_id: that.reginWhere.type_id,
        region_id: that.reginWhere.project_region,
        place_id: that.reginWhere.place_id,
      });
      that.setLegalSearchObj();
      that.$emit("onHeader",that.reginWhere);
    },
    // 选择战区
    selectProjectRegin() {
      const that=this;
      let project_region_id = 0;
      that.reginWhere.project_region_level=UserProjectInfo.getRegionLevel(that.reginWhere.project_region)
      that.reginWhere.project_list = [];
      that.reginWhere.area_list = [];
      that.reginWhere.project_name = '';
      that.reginWhere.area_id = '';
      that.reginWhere.group_by = 'project';

      that.reginWhere.project_ids = UserProjectInfo.getProjectIds({
        type_id: that.reginWhere.type_id,
        region_id: that.reginWhere.project_region,
        place_id: that.reginWhere.place_id,
      });

      //获取项目列表
      that.reginWhere.project_list = UserProjectInfo.getProjectList({
        type_id: that.reginWhere.type_id,
        region_id: that.reginWhere.project_region,
        place_id: that.reginWhere.place_id,
      });
      that.setLegalSearchObj();
      that.$emit("onHeader",that.reginWhere);
    },
    // 选择项目
    selectProject() {
      const that=this;
      // 物业端完成率
      that.reginWhere.group_by = 'project';
      that.reginWhere.area_list = [];
      that.reginWhere.area_id = '';
      that.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };

      //获取战区
      that.reginWhere.area_list = UserProjectInfo.getAreaList(that.reginWhere.project_name);
      that.setLegalSearchObj();
      that.$emit("onHeader",that.reginWhere);
    },
    selectArea(){
      const that=this;
      // 物业端完成率
      // that.reginWhere.group_by = 'project';
      that.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      that.setLegalSearchObj();
      that.$emit("onHeader",that.reginWhere);
    },
    setLegalSearchObj(){
      const that=this;
      that.setSearch('type_id',that.reginWhere.type_id);
      that.setSearch('place_id',that.reginWhere.place_id);
      that.setSearch('region_id',that.reginWhere.project_region);
      that.setSearch('project_id',that.reginWhere.project_name);
      that.setSearch('area_id',that.reginWhere.area_id);
      that.reginWhere.level=that.getLevel();
    },
    initLegalSearchObj(){
      const that=this;
      that.reginWhere.type_id=that.getSearch('type_id');
      that.reginWhere.place_id=that.getSearch('place_id');
      that.reginWhere.project_region=that.getSearch('region_id');
      that.reginWhere.project_name=that.getSearch('project_id');
      that.reginWhere.area_id=that.getSearch('area_id');
      that.reginWhere.project_region_level=UserProjectInfo.getRegionLevel(that.reginWhere.project_region)

      that.reginWhere.type_list=UserProjectInfo.getTypeList();
      that.reginWhere.place_list=UserProjectInfo.getPlaceList(that.reginWhere.type_id);
      that.reginWhere.project_region_list=UserProjectInfo.getRegionList({
        type_id: that.reginWhere.type_id,
        place_id: that.reginWhere.place_id,
      });
      that.reginWhere.project_list=UserProjectInfo.getProjectList({
        type_id: that.reginWhere.type_id,
        region_id: that.reginWhere.project_region,
        place_id: that.reginWhere.place_id,
      });


      if(that.reginWhere.type_id||that.reginWhere.project_region){
        if(that.reginWhere.type_id){
          that.reginWhere.project_ids=UserProjectInfo.getProjectIds({
            type_id: that.reginWhere.type_id,
            region_id: that.reginWhere.project_region,
            place_id: that.reginWhere.place_id,
          })
        }
        if(that.reginWhere.project_region){
          that.reginWhere.project_ids=UserProjectInfo.getProjectIds({
            type_id: that.reginWhere.type_id,
            region_id: that.reginWhere.project_region,
            place_id: that.reginWhere.place_id,
          })
        }
      }else {
        that.reginWhere.project_ids=UserProjectInfo.getProjectIds()
      }

      if(that.reginWhere.project_name){
        that.reginWhere.area_list=UserProjectInfo.getAreaList(that.reginWhere.project_name)
      }
      that.reginWhere.level=that.getLevel();
      that.$emit("onHeader",that.reginWhere);
    },
    getLevel(){
      const that = this;
      let level=0;
      if(that.reginWhere.area_id){
        level=5;
      }else if(that.reginWhere.project_name){
        level=4;
      }else if(that.reginWhere.project_region){
        if(that.reginWhere.project_region_level===1){
          level=2;
        }else if(that.reginWhere.project_region_level===2){
          level=3;
        }
      }else {
        level=1;
      }
      return level;
    },
    setSearch(key,val){
      let obj=search_condition.get()||{}
      obj[key]=val;
      search_condition.set(obj)
    },
    getSearch(key){
      let obj=search_condition.get()
      return (obj||{})[key]||null;
    },
  },
  watch:{
    reginWhere:{
      handler(newVal,oldVal){
        this.setLegalSearchObj();
        this.$emit("onHeader",this.reginWhere);
      },
      deep:true
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  padding-top: 5px;
  padding-bottom: 10px;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/common/SelectCdjProjectHeaderNotArea.vue